import { render, staticRenderFns } from "./ArticleLabel.vue?vue&type=template&id=50b97c76&scoped=true"
import script from "./ArticleLabel.vue?vue&type=script&lang=js"
export * from "./ArticleLabel.vue?vue&type=script&lang=js"
import style0 from "./ArticleLabel.vue?vue&type=style&index=0&id=50b97c76&prod&lang=scss&scoped=true"
import style1 from "./ArticleLabel.vue?vue&type=style&index=1&id=50b97c76&prod&lang=scss&scoped=true"
import style2 from "./ArticleLabel.vue?vue&type=style&index=2&id=50b97c76&prod&lang=scss&scoped=true"
import style3 from "./ArticleLabel.vue?vue&type=style&index=3&id=50b97c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b97c76",
  null
  
)

export default component.exports